import { util } from '.'
import { constants } from '../constants'
import { strings } from '../context/LanguageContext/strings'

export const storesUtil = {
    getPercentageColor: percentage => {
        if (percentage <= 50) {
            return constants.color.red
        } else if (percentage >= 51 && percentage <= 85) {
            return constants.color.orange
        } else if (percentage >= 86) {
            return constants.color.success_green
        }
    },
    configureStoreOptions: (currFilters, devices, type) => {
        const updatedFilters = util.cloneArrOfObj(currFilters)
        /** Merging the devices info with the current filters */

        devices.forEach(device => {
            updatedFilters.push({
                key: device.key,
                display_name: device.localizations?.name ?? device.name,
                type: 'option',
                isOn: false,
                isOff: false,
                groupBy: type,
                post_value: [],
                display_value: [],
                postUtil: function ({ key, isOn, isOff, groupBy }) {
                    const postArr = []
                    if (isOn) {
                        postArr.push({ key: groupBy, name: key, status: true })
                    }
                    if (isOff) {
                        postArr.push({ key: groupBy, name: key, status: false })
                    }
                    return postArr
                },
                displayUtil: function ({ isOn, isOff }) {
                    return `${isOn && isOff ? 'On, Off' : isOn ? 'On' : isOff ? 'Off' : ''}`
                },
                displayPillUtil: value => {
                    if (value === 'On') return strings.ON
                    if (value === 'Off') return strings.OFF
                    if (value === 'On, Off') return `${strings.ON}, ${strings.OFF}`
                    return value
                },
                initialize: function () {
                    return {
                        type: this.type,
                        key: this.key,
                        isOn:
                            this.post_value.length &&
                            !!this.post_value.find(({ status }) => status),
                        isOff:
                            this.post_value.length &&
                            !!this.post_value.find(({ status }) => !status),
                        groupBy: this.groupBy,
                        display_name: this.display_name,
                    }
                },
            })
        })

        return updatedFilters
    },
    getFilteredMarkets: (markets, marketplaces) => {
        const filteredMarketplacesList = marketplaces.map(marketplace => {
            return marketplace._id
        })
        const updatedMarketsList = markets.filter(market => {
            return filteredMarketplacesList.includes(market)
        })

        return updatedMarketsList
    },
}
